import { Skeleton } from '@material-ui/lab';
import { Grid } from '@material-ui/core';
import classes from '../Styles/globalStyles.module.css';

const LoaderPage = () => {
  return (
    <div className={classes.mainContainer}>
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12} lg={8}>
          <Skeleton variant="rect" width="100%" height="90vh" style={{ borderRadius: '0.5rem' }} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <Skeleton variant="rect" width="100%" height="90vh" style={{ borderRadius: '0.5rem' }} />
        </Grid>
      </Grid>
    </div>
  );
};

export default LoaderPage;
